import React from 'react';
import './nav.css'
import logo from './../../../assets/logo.svg';
import Navitem1 from '../common/navitem';
import Button1 from '../common/button';
import burger from './../../../assets/burger.svg'
import close from './../../../assets/close.svg'

import { useState } from 'react';

// FUNCTIONS
const Navbar = (props) => {

    const [isOpen, setIsOpen] = useState(false);

    const openPopup = () => {
        setIsOpen(true);
    };

    const closePopup = () => {
        setIsOpen(false);
    };


// CODE
    return ( <>
    <header>
        <div className="logo">
            <img src={logo} alt="" />
        </div>
       <nav>
         <ul>
            <Navitem1 link="/" title="Home" />
            <Navitem1 link="/properties" title="Properties" />
            <Navitem1 link="/details" title="Details" />
        </ul>
       </nav>
            <div className="btnFlex">
                    <Button1 style2="secondarySmall" cta="Log In" />
                    <Button1 style2="primarySmall" cta="Start Exploring" />
            </div>
            {/* BURGERMENU */}
        <button className='burgermenu' onClick={openPopup}> <img src={burger} alt="" /></button>
    </header>

    <div className={`popUp ${isOpen ? "show" : "hide"}`}>
        <div>
            <ul>
                <Navitem1 link="/" title="Home" />
                    <Navitem1 link="/properties" title="Properties" />
                    <Navitem1 link="/details" title="Details" />
            </ul>
            {/* CLOSEBTN */}
            <button className='closed'  onClick={closePopup}><img src={close} alt="" /></button>
        </div>
    </div>
    </> );
}

export default Navbar;